import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import { parseErrorArrayAndThrowMsg } from 'api/utils';

const DataApiUrl = dataApiUrl();

const RoyaltyTransfers = () => {
  const getAll = params => {
    // Check if URL would be too long for GET request
    const queryString = new URLSearchParams(params?.params || {}).toString();
    const estimatedUrlLength = `${DataApiUrl}/admin/royaltyTransfers?${queryString}`.length;

    // Use POST for large parameter sets (URL > 2000 chars or any __in parameter with many values)
    const shouldUsePost =
      estimatedUrlLength > 2000 ||
      (params?.params?.royalty_transfer_id__in &&
        typeof params.params.royalty_transfer_id__in === 'string' &&
        params.params.royalty_transfer_id__in.length > 1000) ||
      (params?.params?.account_info__in &&
        typeof params.params.account_info__in === 'string' &&
        params.params.account_info__in.length > 1000);

    if (shouldUsePost) {
      // Use POST with body for large queries
      const { params: bodyParams = {}, ...otherParams } = params || {};
      return AuthAxios.post(`${DataApiUrl}/admin/royaltyTransfers`, bodyParams, {
        params: otherParams,
      })
        .then(res => res.data.data)
        .catch(err => {
          throw err.response;
        });
    } else {
      // Use GET for normal queries
      return AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers`, params)
        .then(res => res.data.data)
        .catch(err => {
          throw err.response;
        });
    }
  };

  const getCompanyStripeBalanceUSD = () =>
    AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers/companyStripeBalanceUSD`)
      .then(res => res.data.data.balance)
      .catch(err => {
        throw err.response;
      });

  const getCompanyWalletBalanceWei = () =>
    AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers/companyWalletBalanceWei`)
      .then(res => res.data.data.balance)
      .catch(err => {
        throw err.response;
      });

  const getTotalPayable = () =>
    AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers/totalPayable`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const getRoyaltyTransfer = id =>
    AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const close = id =>
    AuthAxios.post(`${DataApiUrl}/admin/royaltyTransfers/${id}/close`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const patch = (id, patchObject) =>
    AuthAxios.patch(`${DataApiUrl}/admin/royaltyTransfers/${id}`, patchObject)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const executeExternalTransfer = id =>
    AuthAxios.post(`${DataApiUrl}/admin/royaltyTransfers/${id}/execute`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const refreshTransferAmount = id =>
    AuthAxios.post(`${DataApiUrl}/admin/royaltyTransfers/${id}/refreshAmount`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const exportTransferCsv = id =>
    AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers/${id}/export`)
      .then(res => {
        window.confirm(`Statement email will be sent to ${res.data.data.job.data.recipientEmail}`);
      })
      .catch(err => {
        throw err.response;
      });

  const unwindRoyalyTransfers = id =>
    AuthAxios.post(`${DataApiUrl}/admin/royaltyTransfers/${id}/uncreateRoyalties`).catch(
      parseErrorArrayAndThrowMsg('unwind')
    );

  const queueAllPayableStripeTransfers = () =>
    AuthAxios.get(`${DataApiUrl}/admin/royaltyTransfers/queue-execute-all`).then(res => res.data.data);

  const queueCloseAllPayableRoyalties = () =>
    AuthAxios.post(`${DataApiUrl}/admin/royaltyTransfers/queue-close-all-payable-royalties`).then(res => res.data.data);

  return {
    getAll,
    getRoyaltyTransfer,
    getCompanyStripeBalanceUSD,
    getCompanyWalletBalanceWei,
    getTotalPayable,
    close,
    patch,
    executeExternalTransfer,
    exportTransferCsv,
    refreshTransferAmount,
    unwindRoyalyTransfers,
    queueAllPayableStripeTransfers,
    queueCloseAllPayableRoyalties,
  };
};

export default RoyaltyTransfers;
